<template>
	<div class='knd-icon knd-svg-icon knd-icon-mute' >
	
      <svg viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">

        <g :class="{'mute': muted, 'unmute': !muted}">
          <circle class='circle' cx="13.399" cy="13.399" r="10.4402" transform="rotate(165 13.399 13.399)" />
          <path class="icon-fill icon-stroke" d="M8.61257 18.8691C9.74547 18.8691 10.6639 17.9507 10.6639 16.8178C10.6639 15.6849 9.74547 14.7665 8.61257 14.7665C7.47967 14.7665 6.56128 15.6849 6.56128 16.8178C6.56128 17.9507 7.47967 18.8691 8.61257 18.8691Z"  stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="icon-fill" d="M16.8178 18.1853C17.9507 18.1853 18.8691 17.2669 18.8691 16.134C18.8691 15.0011 17.9507 14.0827 16.8178 14.0827C15.6849 14.0827 14.7665 15.0011 14.7665 16.134C14.7665 17.2669 15.6849 18.1853 16.8178 18.1853Z"  stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path class="icon-fill" d="M18.869 6.56134L10.6638 8.61263V11.3477L18.869 9.2964V6.56134Z" />
          <path class="icon-fill icon-stroke" d="M10.6638 16.8178V11.3477ZM18.869 16.134V9.2964ZM10.6638 11.3477V8.61263L18.869 6.56134V9.2964M10.6638 11.3477L18.869 9.2964Z" />
          <path class="icon-stroke" d="M10.6638 16.8178V11.3477M10.6638 11.3477V8.61263L18.869 6.56134V9.2964M10.6638 11.3477L18.869 9.2964M18.869 16.134V9.2964" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
          <g class="mute" v-if="muted">
            <path class='slash' d="M5.5 7L21.5 20" />
          </g>
        </g>
        <defs>
        <linearGradient id="paint0_linear_340_135" x1="7.10836" y1="4.09979" x2="20.7836" y2="29.8093" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF5362"/>
        <stop offset="1" stop-color="#4E243F"/>
        </linearGradient>

        <linearGradient id="paint0_linear_339_128" x1="7.10836" y1="4.09979" x2="20.7836" y2="29.8093" gradientUnits="userSpaceOnUse">
          <stop stop-color="#00D9AD"/>
          <stop offset="1" stop-color="#197946"/>
          </linearGradient>

        </defs>
      </svg>
	</div>
</template>

<script>

import { useStore } from 'vuex'
import { ref, onMounted } from 'vue';

export default {
  props: ['muted'],
  setup () {

    return {
    }
  }
}
</script>


<style lang="scss">
$default-icon-mute-slash-stroke: #FFF;
$default-icon-mute-bg: url('#paint0_linear_340_135');
$default-icon-unmute-bg:  url('#paint0_linear_339_128');
$default-icon-mute-size: 30px;

$default-icon-color: #FFF;

.knd-icon-mute {
	width: var(--icon-mute-size, $default-icon-mute-size);
	height: var(--icon-mute-size, $default-icon-mute-size);

  .circle {
    stroke: #FFF;
  }

  .slash {
    stroke: var(--icon-mute-slash-stroke, $default-icon-mute-slash-stroke);
  }

  .icon-fill {
    fill: var(--icon-mute-icon-color, $default-icon-color);
  }

  .icon-stroke {
    stroke: var(--icon-mute-icon-color, $default-icon-color);
  }


  .mute {
    .circle {
      fill:var(--icon-mute-mute-bg, $default-icon-mute-bg);
    }
  }

  .unmute  {
    .circle {
      fill:var(--icon-mute-unmute-bg, $default-icon-unmute-bg);
    }
  }
}


</style>
<!-- 

import expandIcon from '@/components/icons/mute'; 

--icon-mute-slash-stroke: #000;
--icon-mute-icon-color
--icon-mute-mute-bg
--icon-mute-unmute-bg


 -->
